export default __webpack_public_path__ + "static/media/arysmallbanner.7b5713da.jpg";